export default __webpack_public_path__ + "static/media/Iceland.59d1aa85.png";